/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Dialog_Breaking_BannerInputs */



/**
* | output |
* | --- |
* | "This release contains breaking changes. Please review before upgrading." |
*
* @param {Release_Dialog_Breaking_BannerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_breaking_banner = /** @type {((inputs?: Release_Dialog_Breaking_BannerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_Breaking_BannerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Version enthält Breaking Changes. Bitte vor dem Upgrade prüfen.")
	return /** @type {LocalizedString} */ ("This release contains breaking changes. Please review before upgrading.")
});